module.exports = __webpack_public_path__ + "media/images/photos/photo-7-999a812abc2d1f96a4f86b982c294e9b.jpg";